import React, { FC } from 'react';
import { Button, Modal } from 'antd';
import { IconBackground } from 'common/components';
import { EColor } from 'common/const';
import { InfoRed } from 'common/svg';

interface IComponentProps {
  open: boolean;
  loading: boolean;
  onClose: () => void;
  onAccept: () => void;
}

export const MetaDataDeleteModal: FC<IComponentProps> = ({ open, loading, onClose, onAccept }) => {
  const handleClose = () => {
    if (loading) {
      return;
    }

    onClose();
  };

  return (
    <Modal
      rootClassName="redesign modal"
      width={440}
      centered
      open={open}
      onCancel={handleClose}
      destroyOnClose
      footer={[
        <Button key="cancel" className="button-sm secondary" onClick={handleClose} loading={loading}>
          Отмена
        </Button>,
        <Button key="accept" className="button-sm primary" loading={loading} onClick={onAccept}>
          Удалить
        </Button>,
      ]}
    >
      <div className="mb-7">
        <IconBackground content={<InfoRed className="icon-info-red" />} color={EColor.PaleRed} />
      </div>

      <div className="mb-4 ff-medium fs-m">Вы уверены, что хотите удалить meta_data?</div>
      <div className="mb-4 ff-regular fs-s color-dark-grey">
        Удаление приведет к прекращению передачи дополнительных данных о заказе в учётную систему.
      </div>
      <div className="mb-6 ff-regular fs-s color-dark-grey">
        Для возобновления передачи потребуется заново настроить meta_data.
      </div>
    </Modal>
  );
};
